import {Text, View} from "react-native";
import React from "react";


interface IMessageComponentProps {
    message: string;
}

const MessageComponent =  (props: IMessageComponentProps) => {
    const {message} = props;
    return <View style={{flex:1,justifyContent: 'center', alignItems: 'center' }}><Text style={{fontWeight: "bold"}}>{message}</Text></View>;
};

export default MessageComponent;